import { getRequiredMessage } from '@monetize/types/common';
import { z } from 'zod';
import { StorageReferenceTypeEnumZ, StorageTypeEnumZ } from './enums.types';

export const StorageSchema = z.object({
  id: z.string(),
  filename: z.string(),
  mediaType: z.string(),
  referenceFilename: z.string().nullish(),
  referenceId: z.string().nullish(),
  contentBase64Encoded: z.string().nullish(),
  referenceType: StorageReferenceTypeEnumZ,
  type: StorageTypeEnumZ,
  convertedFileMediaTypes: z.array(z.string()).nullish(),
});
export type IStorage = z.infer<typeof StorageSchema>;

export enum QuoteDocumentConfigPositionEnum {
  BEFORE = 'BEFORE',
  AFTER = 'AFTER',
}

export const QuoteDocumentConfigStatusEnumZ = z.enum(['ACTIVE', 'INACTIVE']);
export const QuoteDocumentConfigPositionEnumZ = z.enum(
  QuoteDocumentConfigPositionEnum,
);

export enum DocumentParentEnum {
  TENANT = 'TENANT',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
}

export enum DocumentSource {
  TENANT = 'TENANT',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  QUOTE = 'QUOTE',
}

export const DocumentParentEnumZ = z.enum(DocumentParentEnum);
export const DocumentSourceZ = z.enum(DocumentSource);

export const QuoteDocumentConfigSchema = z.object({
  id: z.string(),
  storageObjectId: z.string(),
  status: QuoteDocumentConfigStatusEnumZ,
  fileSize: z.number(),
  documentTypeId: z.string(),
  position: QuoteDocumentConfigPositionEnumZ,
  sortWithinPosition: z.number(),
  autoAddToQuotes: z.boolean(),
  storageObject: StorageSchema,
  quoteDocumentType: z.object({
    id: z.string(),
    value: z.string(),
    label: z.string(),
  }),
  parent: DocumentParentEnumZ,
  originalSource: DocumentSourceZ,
});

export const QuoteDocumentConfigSummarySchema = z.object({
  id: z.string(),
  storageObjectId: z.string(),
  status: QuoteDocumentConfigStatusEnumZ,
  documentTypeId: z.string(),
  position: QuoteDocumentConfigPositionEnumZ,
  sortWithinPosition: z.number(),
  originalSource: DocumentSourceZ,
});

export type QuoteDocumentConfig = z.infer<typeof QuoteDocumentConfigSchema>;

export const DocumentDefinitionSchema = z.object({
  id: z.string(),
  configurations: z.array(QuoteDocumentConfigSchema),
});

export type DocumentDefinition = z.infer<typeof DocumentDefinitionSchema>;

export const CreateQuoteDocumentSchema = z.object({
  documentTypeId: z.string().min(1, getRequiredMessage('Document Type')),
  position: QuoteDocumentConfigPositionEnumZ,
  sortWithinPosition: z.number(),
  autoAddToQuotes: z.boolean(),
});

export const UpdateQuoteDocumentSchema = CreateQuoteDocumentSchema.extend({
  id: z.string(),
});

export type CreateQuoteDocument = z.infer<typeof CreateQuoteDocumentSchema>;
export type UpdateQuoteDocument = z.infer<typeof UpdateQuoteDocumentSchema>;
